import React, { Fragment as _, useContext } from 'react';
import { AssessmentContext } from 'components/Module/AssessmentContainer';

const AssessmentQuestionOptions = ({ children, ...props }) => {
  const assessmentContext = useContext(AssessmentContext);

  const { answersWrappingAlignment = 'center' } = assessmentContext;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent:
          answersWrappingAlignment === 'center' ? 'center' : 'flex-start',
      }}
    >
      {[...children].map((child, index) => {
        return React.cloneElement(child, {
          numOptions: children.length,
          index,
        });
      })}
    </div>
  );
};

export default AssessmentQuestionOptions;
